import { useCart } from "@shopify/hydrogen-react";
import { Link } from "atoms";
import { pluralize } from "utils/text";

function CartButton() {
  const { totalQuantity = 0 } = useCart();

  return (
    <div>
      <Link
        to="/dev-shop/cart"
        variant={totalQuantity ? "primary" : "secondary"}
      >
        <span>Cart: </span>
        {totalQuantity ? (
          <span>{pluralize(totalQuantity, "Item")}</span>
        ) : (
          <span>Empty</span>
        )}
      </Link>
    </div>
  );
}

export { CartButton };
